<!--
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-15 15:48:43
 * @LastEditTime: 2020-09-27 09:56:58
 * @Description: 添加车辆信息抽屉
-->
<template>
  <Drawer
    width="400"
    :title="`${openedVehicle ? '编辑' : '新增'}车辆`"
    v-model="drawerOpened"
  >
    <div class="drawer-content">
      <Form
        @submit.native.prevent
        ref="formItem"
        :model="formItem"
        :rules="ruleValidate"
        label-position="top"
      >
        <FormItem
          label="车牌"
          prop="plate"
        >
          <Input
            v-model="formItem.plate"
            placeholder="输入车牌..."
          />
        </FormItem>
        <FormItem
          label="核定载重量（吨）"
          prop="capacity"
        >
          <InputNumber
            :min="0"
            style="width: 100%"
            v-model="formItem.capacity"
            placeholder="输入核定载重量..."
          ></InputNumber>
        </FormItem>
        <FormItem
          label="默认司机"
          prop="defaultDriver"
        >
          <Select v-model="formItem.defaultDriver">
            <Option
              v-for="item in driverList"
              :value="item._id"
              :key="item._id"
            >{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem
          label="默认工厂"
          prop="factory"
        >
          <Select v-model="formItem.factory" multiple>
            <Option
              v-for="item in factoryList"
              :value="item._id"
              :key="item._id"
            >{{ item.name }}</Option>
          </Select>
        </FormItem>
        <div style="margin: 12px 0">
          <Row
            v-for="(item, index) in formItem.storageSection"
            :key="index"
            :gutter="16"
          >
            <Col span="12">
            <FormItem
              :label="`仓位 ${index + 1}`"
              :prop="`storageSection[${index}].name`"
              :rules="{
                  required: true,
                  message: '请输入仓位名',
                  trigger: 'blur',
                }"
            >
              <Input
                v-model="item.name"
                placeholder="例：前仓、中仓、后仓、全仓"
              />
            </FormItem>
            </Col>
            <Col span="8">
            <FormItem
              label="容量（吨）"
              :prop="`storageSection[${index}].capacity`"
              :rules="{
                  required: true,
                  type: 'number',
                  message: '请输入容量',
                  trigger: 'blur',
                }"
            >
              <InputNumber
                :min="0"
                v-model="item.capacity"
                placeholder="该仓位的容量..."
              ></InputNumber>
            </FormItem>
            </Col>
            <Col span="4">
            <Button
              v-if="index !== 0"
              @click="removeStorageSection(index)"
              style="margin-top: 22px"
            >删除</Button>
            </Col>
          </Row>
          <Button
            type="dashed"
            @click="addStorageSection"
            icon="md-add"
          >增加仓位</Button>
        </div>
        <FormItem
          label="禁用"
          prop="invalid"
        >
          <i-switch
            v-model="isInvalid"
            true-color="#ff4949"
            @on-change="changeInvalid"
          ></i-switch>
        </FormItem>
        <FormItem>
          <Button
            type="primary"
            @click="handleSubmit('formItem')"
          >保存</Button>
        </FormItem>
      </Form>
    </div>
  </Drawer>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "EditVehicleDrawer",
  props: {
    msg: String,
  },
  data() {
    return {
      drawerOpened: false,
      isInvalid: false,
      openedVehicle: null,
      formItem: {
        plate: null,
        capacity: null,
        defaultDriver: null,
        invalid: null,
        storageSection: [
          {
            name: "前仓",
            capacity: 0,
            memo: null,
          },
        ],
      },
      selectedFactory: [],
      ruleValidate: {
        plate: [{ required: true, message: "名字为必填项", trigger: "blur" }],
        defaultDriver: [
          { required: true, message: "默认司机为必填项", trigger: "blur" },
        ],
        capacity: [
          {
            required: true,
            type: "number",
            message: "容量为必填项",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState({
      driverList: (state) => state.user.userList,
      factoryList: (state) => state.factory.factoryList,
    }),
  },
  methods: {
    ...mapActions({
      createVehicle: "vehicle/createVehicleAction",
      updateVehicle: "vehicle/updateVehicleAction",
      getUsers: "user/getUsersAction",
    }),
    openDrawer(vehicle) {
      this.$refs["formItem"].resetFields();
      this.formItem.storageSection = [
        {
          name: "前仓",
          capacity: 0,
          memo: null,
        },
      ];
      this.openedVehicle = vehicle; // 如果有打开的材料，则为编辑模式
      if (vehicle) {
        this.formItem.name = this.openedVehicle.name;
        this.formItem.plate = this.openedVehicle.plate;
        this.formItem.capacity = this.openedVehicle.capacity;
        this.formItem.defaultDriver = this.openedVehicle.defaultDriver._id;
        this.formItem.invalid = this.openedVehicle.invalid;
        this.isInvalid = this.openedVehicle.invalid;
        this.formItem.storageSection = this.openedVehicle.storageSection;
      }
      this.drawerOpened = true;
    },
    changeInvalid(status) {
      this.formItem.invalid = status;
      this.isInvalid = status;
    },
    handleSubmit(name) {
      // console.log(this.selectedFactory);
      // console.log(this.selectedFactory.map(v => v._id));
      this.$refs[name].validate(async (valid) => {
        if (valid) {
          try {
            if (this.openedVehicle) {
              await this.updateVehicle({
                id: this.openedVehicle._id,
                data: this.formItem,
              });
            } else {
              await this.createVehicle(this.formItem);
            }
            this.$Message.success("保存成功!");
            this.drawerOpened = false;
          } catch (error) {
            this.$Message.error(`失败: ${error}`);
          }
        } else {
          this.$Message.error("保存失败!");
        }
      });
    },
    addStorageSection() {
      this.formItem.storageSection.push({
        name: "",
        capacity: 0,
        memo: null,
      });
    },
    removeStorageSection(index) {
      this.formItem.storageSection.splice(index, 1);
    },
  },
  mounted() {
    this.getUsers({ simpleRole: "driver", limit: 99 });
  },
};
</script>

<style scoped lang="stylus"></style>
